import { bubEvents } from 'shared/events/bub_events';
import { SiteConversionTrackingHelper, SiteImpressions } from 'shared/events/site_conversion_tracking_helper';
import { ValidatorUtils } from 'javascripts/shared/utils/validator_utils';

$(document).ready(() => {
  $('#image-hero-sign-up-button').click(event => {
    bubEvents.track('Logged Out (Hero)', 'Clicked button', {
      label: 'Sign Up for Free!',
    });

    const signupTracker = new SiteConversionTrackingHelper('Logged Out (Hero)', event);
    signupTracker.trackConversion();
  });

  if ($('#image-hero-sign-up-button').length) {
    SiteImpressions.trackImmediately({
      category: 'Logged Out (Hero)',
      action: 'Viewed button',
      eventLabel: 'Sign Up for Free!',
    });
  }

  if ($('#homepage-sign-up-form-btn').length) {
    SiteImpressions.trackImmediately({
      category: 'Logged Out (Hero)',
      action: 'Viewed button',
      eventLabel: 'Sign Up for Free!',
      eventValue: 'test-group',
    });
  }

  $('#homepage-sign-up-form-btn').click(() => {
    const emailAddress = document.getElementById('homepage-sign-up-form-email-input').value;

    if (
      $('#homepage-sign-up-form-email-input').length &&
      emailAddress.length > 0 &&
      ValidatorUtils.email(emailAddress)
    ) {
      bubEvents.track('Logged Out (Hero)', 'Clicked button', {
        label: 'Sign Up for Free!',
        value: 'test-group',
      });

      bubEvents.track('Logged Out (Hero)', 'Clicked site signup element', {
        label: 'Sign Up for Free!',
        properties: {
          email: emailAddress,
        },
      });
    }
  });

  // Associated with email form CTA or US users
  $('#marketing-landing-homepage-sign-up-form').submit(event => {
    const signupTracker = new SiteConversionTrackingHelper('Unbeatable Deals Header', event);
    signupTracker.trackConversion();
  });

  // Associated with sign up button CTA or non-US users
  $('#marketing-landing-page-hero-sign-up-button').click(event => {
    const signupTracker = new SiteConversionTrackingHelper('Unbeatable Deals Header', event);
    signupTracker.trackConversion();
  });
});
